module.exports = __webpack_public_path__ + "static/media/ring_to_friend.ee7f14cf.png";